import React from 'react';
import PropTypes from 'prop-types';
import ExpandableSection from '../../expandableSection';
import {
  IssueTable,
  RiskTable,
  RiskTabs,
  RiskSummary,
} from './riskRegisterSectionParts';

const RiskRegisterSection = ({
  sectionId,
  expanded,
  onToggle,
  onDownload,
  onMore,
  onMoreMenuItems,
  showMoreAction,
  riskRegisterData: __riskRegisterData,
  visibleTabs,
  activeRiskTab,
  setActiveRiskTab,
  activeRiskTabKey,
  summaryConfig,
  riskRingData,
  isInfoSecTab,
  issueRows,
  expandedRiskRows,
  toggleRiskRow,
  canEditIssue,
  canDeleteIssue,
  handleIssueEdit,
  handleIssueDelete,
  visibleRiskRows,
  canEditInfoSec,
  canEditRisk,
  canDeleteInfoSec,
  canDeleteRisk,
  handleInfoSecEdit,
  handleRiskEdit,
  handleInfoSecDelete,
  handleRiskDelete,
  isLoading,
}) => (
  <ExpandableSection
    sectionId={sectionId}
    title="Risk register"
    expanded={expanded}
    onToggle={onToggle}
    onDownload={onDownload}
    onMore={onMore}
    onMoreMenuItems={onMoreMenuItems}
    showMoreAction={showMoreAction}
    isLoading={isLoading}
  >
    <div className="section-content risk-section">
      <RiskTabs
        visibleTabs={visibleTabs}
        activeRiskTab={activeRiskTab}
        setActiveRiskTab={setActiveRiskTab}
      />

      <RiskSummary
        activeRiskTabKey={activeRiskTabKey}
        summaryConfig={summaryConfig}
        riskRingData={riskRingData}
      />

      {activeRiskTabKey === 'issue' ? (
        <IssueTable
          issueRows={issueRows}
          expandedRiskRows={expandedRiskRows}
          toggleRiskRow={toggleRiskRow}
          canEditIssue={canEditIssue}
          canDeleteIssue={canDeleteIssue}
          handleIssueEdit={handleIssueEdit}
          handleIssueDelete={handleIssueDelete}
        />
      ) : (
        <RiskTable
          isInfoSecTab={isInfoSecTab}
          visibleRiskRows={visibleRiskRows}
          expandedRiskRows={expandedRiskRows}
          toggleRiskRow={toggleRiskRow}
          canEditInfoSec={canEditInfoSec}
          canEditRisk={canEditRisk}
          canDeleteInfoSec={canDeleteInfoSec}
          canDeleteRisk={canDeleteRisk}
          handleInfoSecEdit={handleInfoSecEdit}
          handleRiskEdit={handleRiskEdit}
          handleInfoSecDelete={handleInfoSecDelete}
          handleRiskDelete={handleRiskDelete}
        />
      )}
    </div>
  </ExpandableSection>
);

RiskRegisterSection.propTypes = {
  sectionId: PropTypes.string,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onDownload: PropTypes.func,
  onMore: PropTypes.func,
  onMoreMenuItems: PropTypes.array,
  showMoreAction: PropTypes.bool,
  riskRegisterData: PropTypes.object.isRequired,
  visibleTabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeRiskTab: PropTypes.string.isRequired,
  setActiveRiskTab: PropTypes.func.isRequired,
  activeRiskTabKey: PropTypes.string.isRequired,
  summaryConfig: PropTypes.shape({
    total: PropTypes.number,
    breakdown: PropTypes.array,
    cards: PropTypes.array,
  }).isRequired,
  riskRingData: PropTypes.array.isRequired,
  isInfoSecTab: PropTypes.bool.isRequired,
  issueRows: PropTypes.array.isRequired,
  expandedRiskRows: PropTypes.object.isRequired,
  toggleRiskRow: PropTypes.func.isRequired,
  canEditIssue: PropTypes.bool.isRequired,
  canDeleteIssue: PropTypes.bool.isRequired,
  handleIssueEdit: PropTypes.func.isRequired,
  handleIssueDelete: PropTypes.func.isRequired,
  visibleRiskRows: PropTypes.array.isRequired,
  canEditInfoSec: PropTypes.bool.isRequired,
  canEditRisk: PropTypes.bool.isRequired,
  canDeleteInfoSec: PropTypes.bool.isRequired,
  canDeleteRisk: PropTypes.bool.isRequired,
  handleInfoSecEdit: PropTypes.func.isRequired,
  handleRiskEdit: PropTypes.func.isRequired,
  handleInfoSecDelete: PropTypes.func.isRequired,
  handleRiskDelete: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

RiskRegisterSection.defaultProps = {
  sectionId: '',
  isLoading: false,
};

export default RiskRegisterSection;
